package one.healthium.pcos.presentation.navigation.log_period

import com.arkivanov.decompose.ComponentContext

class DefaultLogPeriodComponent(
    componentContext: ComponentContext,
    override val taskId: String?,
    private val onCloseClicked: () -> Unit,
    private val onPeriodUpdated: () -> Unit,
) : LogPeriodComponent, ComponentContext by componentContext {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }
    override fun onPeriodUpdated() {
        onPeriodUpdated.invoke()
    }
}